<h2 mat-dialog-title>Editar acceso al tablero</h2>

<mat-dialog-content [formGroup]="form_group" class="role-edit-dialog">
  <div class="role-edit-dialog__summary">
    <span class="role-edit-dialog__name">{{ data.role.name || 'Usuario sin nombre' }}</span>
    <span class="role-edit-dialog__role">{{ data.role.role }}</span>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Correo autorizado</mat-label>
    <input matInput formControlName="email" placeholder="usuario@correo.com" />
    <mat-error *ngIf="form_group.get('email')?.hasError('required')">El correo es obligatorio.</mat-error>
    <mat-error *ngIf="form_group.get('email')?.hasError('email')">Ingresa un correo valido.</mat-error>
  </mat-form-field>

  @if (vm$ | async; as vm) {
    <div class="role-edit-dialog__parameters">
      <div class="role-edit-dialog__parameters-header">
        <div>
          <h3>Parametros</h3>
        </div>

        <button mat-stroked-button type="button" (click)="add_parameter()" [disabled]="!vm.can_add_parameters">
          <mat-icon>add</mat-icon>
          Agregar
        </button>
      </div>

      @if (!vm.can_add_parameters) {
        <p class="role-edit-dialog__empty-state">
          Este tablero todavía no tiene parameters_objects configurados. No se pueden crear parámetros nuevos.
        </p>
      }

      <div formArrayName="parameters" class="role-edit-dialog__parameter-list">
        @for (row of vm.rows; track row.form_group; let index = $index) {
          <div class="role-edit-dialog__parameter-row" [formGroup]="row.form_group">
            @for (field of row.fields; track field.control_name) {
              <mat-form-field appearance="outline">
                <mat-label>{{ field.label }}</mat-label>

                @switch (field.input_type) {
                  @case ('select') {
                    <mat-select [formControlName]="field.control_name">
                      @for (option of field.options ?? []; track option.value) {
                        <mat-option [value]="option.value"  >
                          {{ option.view_value }}
                        </mat-option>
                      }
                    </mat-select>
                  }

                  @case ('number') {
                    <input matInput type="number" [formControlName]="field.control_name" [placeholder]="field.placeholder || ''" />
                  }

                  @case ('date') {
                    <input matInput type="date" [formControlName]="field.control_name" [placeholder]="field.placeholder || ''" />
                  }

                  @default {
                    <input matInput [formControlName]="field.control_name" [placeholder]="field.placeholder || ''" />
                  }
                }
              </mat-form-field>
            }


            <button mat-icon-button color="warn" type="button" (click)="remove_parameter(index)" aria-label="Eliminar parametro">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Guardar</button>
</mat-dialog-actions>
